var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"mx-4",attrs:{"color":"accent"}},[_c('v-card-text',[_c('span',{staticStyle:{"font-size":"18px"}},[_vm._v(_vm._s(_vm.getTranslation(`${_vm.name}.steps.${_vm.activeStep}.pages.${_vm.currentStep}.description`)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }